import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';
import type React from 'react';
import { FormattedMessage } from 'react-intl';

export const SuccessPage = ({ displayTextId, children }: { displayTextId: string; children?: React.ReactNode }) => {
    const showCloseButton = window.top === window.self;
    const closeWindow = () => window.close();
    return (
        <ApplicationLayout>
            <ApplicationLayout.Body>
                <div className='container-fluid fluid-small panel'>
                    <div className='text-center panel-body margin-20'>
                        <div className='text-color-success'>
                            <span className='uikit-icon icon-ok text-size-h1' aria-hidden='true' />
                        </div>
                        <h3 className='text-color-success'>
                            <FormattedMessage id={displayTextId} />
                        </h3>
                        {children}
                        {showCloseButton && (
                            <div className='margin-top-20'>
                                <button type={'button'} className={'btn btn-primary'} onClick={closeWindow}>
                                    <FormattedMessage id={'intl-msg:contactForm.close'} />
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </ApplicationLayout.Body>
        </ApplicationLayout>
    );
};
